const CLIENT_VERSION = "3.03";
  
export default CLIENT_VERSION;